import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const Splash = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 99 9">
    <path fill="#fff" d="M47 6h52v1H47zM18 0h44v1H18zM0 8h36v1H0z" />
  </svg>,
);
